import { List,Map } from "immutable";

import { createFromJS,immutableRecords } from "../../types";
import combineReducersWithGlobal from "../combineReducersWithGlobal";
import { itemActionTypes } from "../items";
import isSuperValid from "../items/reducers/byId/isSuperValid";
import itemSelectors from "../items/selectors";
import { dependencySelectors } from ".";
import { actionTypes } from "./actions";
import selectors from "./selectors";

// const isDependencyAffected = (d, ids) => {
//   const g = d.id;
//   return Array.isArray(ids) ? ids.indexOf(g) !== -1 : g === ids;
// };

const doesDependencyMatchPairs = (d, subjects, objects) => {
  const l = subjects.length;
  for (let i = 0; i < l; i++) {
    if (d.subject === subjects[i] && d.object === objects[i]) {
      return true;
    }
  }
  return false;
};

const createDependency = (id, subject, object, dependencyType) =>
  immutableRecords.DependencyRecord({
    id,
    subject,
    object,
    dependencyType
  });

const createDependencies = (state, ids, subjects, objects, dependencyType, globalState) => {
  return state.withMutations(s => {
    for (let i = 0; i < ids.length; i++) {
      const rId = ids[i];
      const subjectId = subjects[i];
      const itemId = objects[i];
      if (!dependencySelectors.doesDependencyExist(globalState, subjectId, itemId)) {
        s.set(rId, createDependency(rId, subjectId, itemId, dependencyType));
      }
    }
  });
};

const createChainDependencies = (state, ids, itemIds, dependencyType, globalState) => {
  return state.withMutations(s => {
    for (let i = 0; i < itemIds.length - 1; i++) {
      const rId = ids[i];
      if (!dependencySelectors.doesDependencyExist(globalState, itemIds[i], itemIds[i + 1])) {
        s.set(rId, createDependency(rId, itemIds[i], itemIds[i + 1], dependencyType));
      }
    }
  });
};

const setDependencyType = (d, dependencyType) => {
  return d.set("dependencyType", dependencyType);
};

const getDependenciesToDeleteWhenSetSuper = (state, superId, childrenIds) => {
  let depIdsToDelete = List();
  if (superId) {
    const itemsById = itemSelectors.getItemsById(state);
    childrenIds.forEach(id => {
      const child = itemsById.get(id);
      if (child.super !== superId && isSuperValid(state, child, superId)) {
        depIdsToDelete = depIdsToDelete.concat(dependencySelectors.getDependencyIdsBetweenItems(state, [superId, id]));
      }
    });
  }
  return depIdsToDelete;
};

const byId = (state = Map(), action, globalState) => {
  switch (action.type) {
    case actionTypes.CREATE_DEPENDENCIES:
      return createDependencies(state, action.ids, action.subjects, action.objects, action.dependencyType, globalState);
    case actionTypes.CREATE_CHAIN_DEPENDENCIES:
      return createChainDependencies(state, action.ids, action.itemIds, action.dependencyType, globalState);
    // case actionTypes.CHANGE_DEPENDENCY_TYPE:
    //   return state.map(d => (isDependencyAffected(d, action.ids) ? setDependencyType(d, action.dependencyType) : d));
    case actionTypes.CHANGE_DEPENDENCY_TYPE_WITH_VALUES:
      return state.map(d =>
        doesDependencyMatchPairs(d, action.subjects, action.objects) ? setDependencyType(d, action.dependencyType) : d
      );
    case actionTypes.REMOVE_DEPENDENCIES:
      return state.deleteAll(action.ids);
    case actionTypes.REMOVE_DEPENDENCIES_WITH_VALUES: {
      return state.filter(d => !doesDependencyMatchPairs(d, action.subjects, action.objects));
    }
    case actionTypes.REMOVE_DEPENDENCIES_WITH_SUBJECTS: {
      return state.filter(d => !action.subjects.includes(d.subject));
    }
    case actionTypes.REMOVE_DEPENDENCIES_WITH_OBJECTS: {
      return state.filter(d => !action.objects.includes(d.object));
    }
    case itemActionTypes.DELETE_ITEMS: {
      const dependencyIds = selectors.getDependenciesToBeDeletedWithItems(globalState, action.ids);
      return state.deleteAll(dependencyIds);
    }
    case itemActionTypes.SET_SUPER: {
      const depIds = getDependenciesToDeleteWhenSetSuper(globalState, action.superId, action.ids);
      return state.deleteAll(depIds);
    }
    default:
      return state;
  }
};

const allIds = (state = List(), action, globalState) => {
  switch (action.type) {
    case actionTypes.CREATE_DEPENDENCIES:
      return state.push(
        ...action.ids.filter((_id, index) => {
          return !dependencySelectors.doesDependencyExist(globalState, action.subjects[index], action.objects[index]);
        })
      );
    case actionTypes.CREATE_CHAIN_DEPENDENCIES:
      return state.push(
        ...action.ids.filter((_id, index) => {
          return !dependencySelectors.doesDependencyExist(
            globalState,
            action.itemIds[index],
            action.itemIds[index + 1]
          );
        })
      );
    case actionTypes.REMOVE_DEPENDENCIES:
      return state.filter(id => action.ids.indexOf(id) === -1);
    case actionTypes.REMOVE_DEPENDENCIES_WITH_VALUES: {
      return state.filter(
        id => !doesDependencyMatchPairs(globalState.data.dependencies.byId.get(id), action.subjects, action.objects)
      );
    }
    case actionTypes.REMOVE_DEPENDENCIES_WITH_SUBJECTS: {
      return state.filter(id => !action.subjects.includes(globalState.data.dependencies.byId.get(id).subject));
    }
    case actionTypes.REMOVE_DEPENDENCIES_WITH_OBJECTS: {
      return state.filter(id => !action.objects.includes(globalState.data.dependencies.byId.get(id).object));
    }
    case itemActionTypes.DELETE_ITEMS: {
      const dependencyIds = selectors.getDependenciesToBeDeletedWithItems(globalState, action.ids);
      return state.filter(id => dependencyIds.indexOf(id) === -1);
    }
    case itemActionTypes.SET_SUPER: {
      const depIds = getDependenciesToDeleteWhenSetSuper(globalState, action.superId, action.ids);
      return state.filter(id => depIds.indexOf(id) === -1);
    }
    default:
      return state;
  }
};

export default combineReducersWithGlobal(createFromJS.IdReferenceList("DependencyRecord", {}), {
  byId,
  allIds
});
